export default {
  PAID: 'T',
  NOT_PAID: 'F',
  PARTIAL_PAID: 'M'
}



// WEBPACK FOOTER //
// ./src/components/menus/cafe24/enums/PaidType.js